import { Container, Row, Col } from "react-bootstrap";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";


function Experience() {
  
 
  return (
    <div>
      <Container fluid className="resume-section">
      

<Container>
        <Row>
        <h1 class="vw-page-title">Experience</h1>
   
        </Row>

        <Row>

        <Col xs={12} md={12}>
<p>I am currently a Sofware Engineer at Heartland Business Systems. I develop and maintain websites and custom apps for customers all over the world. I primarily work with the .net stack but do have some experience with php. I work with a variety of different CMS tools including; Kentico and WordPress. For a full listing of my experience, please find me on LinkedIn.</p>
      </Col>
    
        
        
        </Row>
</Container>
       








<hr/>


<div class="timeline">
  <div class="container left">
    <div class="content">
      <h2>Software Engineer II</h2>
      <h5>Heartland Business Systems</h5>
      <h5>May 2022 - Present</h5>
      
      <p>Lorem ipsum dolor sit amet, quo ei simul congue exerci, ad nec admodum perfecto mnesarchum, vim ea mazim fierent detracto. Ea quis iuvaret expetendis his, te elit voluptua dignissim per, habeo iusto primis ea eam.</p>
    </div>
  </div>
  <div class="container right">
    <div class="content">
      <h2>Software Engineer I</h2>
      <h5>Heartland Business Systems</h5>
      <h5>November 2016 - May 2022</h5>
      <p>Lorem ipsum dolor sit amet, quo ei simul congue exerci, ad nec admodum perfecto mnesarchum, vim ea mazim fierent detracto. Ea quis iuvaret expetendis his, te elit voluptua dignissim per, habeo iusto primis ea eam.</p>
    </div>
  </div>
  <div class="container left">
    <div class="content">
    <h2>Web Systems Analyst</h2>
      <h5>University of Wisconsin-Green Bay · Internship</h5>
      <h5>December 2014 - December 2016</h5>
      <p>Help maintain the different websites owned by UW Green Bay. This included HTML, PHP, WordPress, and Kentico updates.</p>
    </div>
  </div>
  <div class="container right">
    <div class="content">
    <h2>Freelance Web Developer</h2>
      
      <h5>September 2013 - November 2016</h5>
      <p>I have worked with a variety of different businesses and organizations both large and small. I have built and maintained websites for non-profit organizations and sports teams. Some of my work includes: Wisconsin Bowfishing Association, A-F Trap Team, Adams County Chamber of Commerce, Practical Cents, Chick’s Softball Tournament</p>
    </div>
  </div>

</div>

      
      </Container>

    </div>



  );
}

export default Experience;
